// dayjs.locale('ja')

let observer

const app = new Vue({
  el: '#page',
  data: {
    isScrollTop: true,
    fixSidebar: false,
    isVisibleMenu: false,
  },
  mounted() {
    const observer = new IntersectionObserver((entries) => {
      this.isScrollTop = entries[0].isIntersecting

      entries.forEach((entry) => {
        switch (entry.target) {
          case this.$refs.headerSensor:
            this.isScrollTop = entry.isIntersecting
            break

          case this.$refs.sidebarSensor:
            this.fixSidebar = !entry.isIntersecting
            break
        }
      })
    })

    // グローバルナビ用のスクロール監視
    if (this.$refs.headerSensor) {
      observer.observe(this.$refs.headerSensor)
    }

    // サイドバー用スクロール監視
    if (this.$refs.sidebarSensor) {
      observer.observe(this.$refs.sidebarSensor)
    }
  },
  methods: {
    showMenu() {
      this.isVisibleMenu = true
    },
    closeMenu() {
      this.isVisibleMenu = false
    },
  },
})
